/**
 * PUBLIC standalone Commission Estimator (/commission-estimator-public). No login — a sales leader can
 * demo it in a presentation and share it en masse without granting CRM access. Rates come from the bounded
 * anon RPC get_public_commission_estimator_rates (single source of truth, column-bounded); the inputs +
 * live itemized estimate are the shared CommissionEstimatorForm. Standalone shell (outside the CRM layout).
 */
import { useQuery } from "@tanstack/react-query";
import { getPublicCommissionEstimatorRates } from "../services/commissionEstimator.service";
import CommissionEstimatorForm from "../components/commission/CommissionEstimatorForm";

export default function CommissionEstimatorPublic() {
  const {
    data: rates,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["public-commission-estimator-rates"],
    queryFn: getPublicCommissionEstimatorRates,
    staleTime: 10 * 60 * 1000,
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Branded header */}
      <div className="w-full py-6 px-4" style={{ backgroundColor: "#A02428" }}>
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-4">
          <img
            src="/USLSlogonobackground.png"
            alt=""
            className="h-14 w-auto shrink-0"
          />
          <div className="text-center">
            <h1 className="text-3xl font-bold text-white mb-1">
              Commission Calculator
            </h1>
            <p className="text-white text-sm">See what you could earn</p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-4xl p-6">
        {isLoading && <p className="text-sm text-gray-500">Loading…</p>}
        {error && (
          <p className="text-sm text-red-600">
            Could not load commission rates. Please try again.
          </p>
        )}
        {!isLoading && !error && (
          <CommissionEstimatorForm rates={rates ?? []} />
        )}
      </div>

      <p className="px-4 pb-8 text-center text-xs text-gray-400">
        Estimates are for illustration only and are not a guarantee of earnings.
      </p>
    </div>
  );
}
